var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"grey"}},[_vm._v("\n  サマリー\n  "),_c('v-card',[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.summary)}})],1),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8f9de5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/CpAppointmentSummary.vue
// module id = null
// module chunks = 